export class WebStorage {
    constructor() {
        this.storage = window.localStorage;
    }

    async set(key, value) {
        try {
            this.storage.setItem(key, JSON.stringify(value));
            return true;
        } catch (error) {
            console.error('存储数据失败:', error);
            return false;
        }
    }

    async get(key) {
        try {
            const value = this.storage.getItem(key);
            return value ? JSON.parse(value) : null;
        } catch (error) {
            console.error('获取数据失败:', error);
            return null;
        }
    }

    async remove(key) {
        try {
            this.storage.removeItem(key);
            return true;
        } catch (error) {
            console.error('删除数据失败:', error);
            return false;
        }
    }
}